<div class="d-flex flex-column justify-content-center align-items-center" >
  <img [src]="urlImage" alt="Imagem representando a ocorrência de um erro" class="w-50 mb-4">
  <span class="h5 mb-1">{{message}}</span>
  <p>{{altMessage}}</p>
</div>
